const observer = new IntersectionObserver(
  entries => {
    entries.forEach(entry => {
      const { target } = entry

      if (entry.isIntersecting || entry.boundingClientRect.top < 0) {
        if (target.tagName === 'IMG') {
          target.src = target.dataset.src
          target.srcset = `${target.dataset.src2x || target.dataset.src} 2x`

          target.addEventListener('load', () => {
            target.parentNode.classList.add('load')
          })
        } else {
          target.style.backgroundImage = target.dataset.src
        }
        observer.unobserve(target)
      }
    })
  },
  {
    rootMargin: '500px 0px 500px 0px',
  }
)

export default container => {
  container
    .querySelectorAll('[data-lazy]')
    .forEach(image => observer.observe(image))
}
